import { render, staticRenderFns } from "./pago-tarjeta.vue?vue&type=template&id=28d62f5d"
import script from "./pago-tarjeta.vue?vue&type=script&lang=js"
export * from "./pago-tarjeta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports